import { createContext, useContext, useState, useCallback } from 'react';

const ProfileDrawerContext = createContext(null);

export const ProfileDrawerProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openDrawer = useCallback(() => setIsOpen(true), []);
  const closeDrawer = useCallback(() => setIsOpen(false), []);
  const toggleDrawer = useCallback(() => setIsOpen(prev => !prev), []);

  return (
    <ProfileDrawerContext.Provider value={{ isOpen, openDrawer, closeDrawer, toggleDrawer }}>
      {children}
    </ProfileDrawerContext.Provider>
  );
};

export const useProfileDrawer = () => {
  const context = useContext(ProfileDrawerContext);
  if (!context) {
    throw new Error('useProfileDrawer must be used within a ProfileDrawerProvider');
  }
  return context;
};
